var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    {
      staticClass: "panorama-invoice-status",
      style: _vm.setPanoramaInvoiceStatusColorMap()
    },
    [_vm._v("\n  " + _vm._s(_vm.getAbbreviatedPanoramaInvoiceStatus()) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }